const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	teacher_token : localStorage.getItem('teacher-token') || null,
	user_name : localStorage.getItem('user-name') || null,
	user_type : localStorage.getItem('user-type') || null,
	user_mobile : localStorage.getItem('user-mobile') || null,
	user_email : localStorage.getItem('user-email') || null,
	user_school_name : localStorage.getItem('user-school-name') || null,
	user_plan : localStorage.getItem('user-plan') || null,
	is_guest : localStorage.getItem('is-guest') === 'true' || false,
	my_profile : null,
	users : [],
	isOpenSubscribeModal : false,
	isFreeLimitReached : false
}

const getters = {
	getIsOpenSubscribeModal : state => state.isOpenSubscribeModal,
	getIsFreeLimitReached : state => state.isFreeLimitReached,
	getUserName : (state) => state.user_name,
	getUserType : (state) => state.user_type,
	getUserMobile : (state) => state.user_mobile,
	getUserEmail : (state) => state.user_email,
	getUserSchoolName: (state) => state.user_school_name,
	getUserPlan: (state) => state.user_plan,
	getIsGuest: (state) => state.is_guest,
	getUserSystemType : (state) => state.user_department,
	getTeacherToken : (state) => state.teacher_token,
	isLoggedIn : (state) => !!state.teacher_token,
	fetchMyProfile : (state) => state.my_profile,
	fetchUsers : (state) => state.users
}

const actions = {

	toggleSubscribeModal({commit}, data){
		commit('TOGGLE_SUBSCRIBE_MODAL', data)
	},

	toggleFreeLimitReached({commit}, data){
		commit('TOGGLE_FREE_LIMIT_REACHED', data)
	},

	requestUserOtp({commit}, user){
		commit('')
		return $http.post('auth', user)
		
	},
	
	loginUser({commit}, user){
		return $http.post('auth/verify-otp', user).then((response) => {
			if(response.data.success){
				commit('SET_TEACHER_PROFILE', response.data.data)
			}
		})
	},
	
	signupUser(context, signupDetails){
		return $http.post('user', signupDetails).then((response) => {
			if(response.data.success){
				// No need to commit anything here as we're redirecting to login
				return response
			}
		})
	},

	simpleSignupUser(context, signupData){
		// Simple signup with minimal data for free users
		return $http.post('user/simple-signup', signupData).then((response) => {
			if(response.data.success){
				return response
			}
		})
	},

	guestLogin({commit}){
		// Guest auto-login - no parameters needed
		return $http.post('user/guest-login').then((response) => {
			if(response.data.success){
				commit('SET_TEACHER_PROFILE', response.data.data)
			}
		})
	},

	loginSchoolUser({commit}, user){
		return $http.post('auth/school', user).then((response) => {
			if(response.data.success){
				commit('SET_TEACHER_PROFILE', response.data.data)
			}
		})
	},

	logoutUser({commit}){
		commit('REMOVE_TEACHER_TOKEN')
	},

	loadUsers({commit}, {token}){
		return $http.get('user', {
			headers : {
				'x-auth-token' : token
			}
		}).then(response => {
			commit('SET_USERS', response.data)
		})
	},

	loadProfile({commit}, {token}){
		return $http.get('user/me', {
			headers : {
				'x-auth-token' : token
			}
		}).then(response => {
			commit('SET_MY_PROFILE', response.data)
		})
	},

	updateProfile({commit}, {profile, token}){
		let formdata = new FormData()
		for(let key in profile){
			if(profile[key]){
				formdata.append(key, profile[key])	
			}
			
		}
		return $http.put('user/me', formdata, {
			headers : {
				'x-auth-token' : token,
				'Content-Type' : 'undefined'
			}
		}).then(response => {
			commit('SET_MY_PROFILE', response.data)
		})
	},
}

const mutations = {
	TOGGLE_SUBSCRIBE_MODAL : (state, data) => {
		state.isOpenSubscribeModal = data
	},

	TOGGLE_FREE_LIMIT_REACHED : (state, data) => {
		state.isFreeLimitReached = data
	},

	SET_USERS : (state, users) => {
		state.users = users
	},
	SET_TEACHER_PROFILE : (state, {name, type, mobile, email, token, school_name, plan, is_guest, classroom, kid}) => {
		state.teacher_token = token
		state.user_name = name
		state.user_type = type
		state.user_mobile = mobile
		state.user_email = email

		localStorage.setItem('teacher-token', token)
		localStorage.setItem('user-name', name)
		localStorage.setItem('user-type', type)
		localStorage.setItem('user-mobile', mobile)
		localStorage.setItem('user-email', email)

		if(school_name){
			state.user_school_name = school_name
			localStorage.setItem('user-school-name', school_name)	
		}

		if(plan){
			state.user_plan = plan
			localStorage.setItem('user-plan', plan)
		}

		if(is_guest !== undefined){
			state.is_guest = is_guest
			localStorage.setItem('is-guest', is_guest.toString())
		}

		// Parent-school context returned from /auth/school
		if(classroom && classroom.name){
			localStorage.setItem('user-classroom-name', classroom.name)
		}else{
			localStorage.removeItem('user-classroom-name')
		}
		if(classroom && classroom.section){
			localStorage.setItem('user-classroom-section', classroom.section)
		}else{
			localStorage.removeItem('user-classroom-section')
		}
		if(kid && kid._id){
			localStorage.setItem('user-kid-id', kid._id)
			localStorage.setItem('user-kid-name', kid.name || '')
		}else{
			localStorage.removeItem('user-kid-id')
			localStorage.removeItem('user-kid-name')
		}
	},

	REMOVE_TEACHER_TOKEN : (state) => {
		localStorage.removeItem('teacher-token')
		localStorage.removeItem('user-name')
		localStorage.removeItem('user-school-name')
		localStorage.removeItem('user-type')
		localStorage.removeItem('user-mobile')
		localStorage.removeItem('user-email')
		localStorage.removeItem('user-plan')
		localStorage.removeItem('is-guest')
		localStorage.removeItem('user-classroom-name')
		localStorage.removeItem('user-classroom-section')
		localStorage.removeItem('user-kid-id')
		localStorage.removeItem('user-kid-name')
		state.teacher_token = null
		state.user_school_name = null
		state.user_name = null
		state.user_type = null
		state.user_mobile = null
		state.user_email = null
		state.user_plan = null
		state.is_guest = false
	},

	SET_MY_PROFILE : (state, profile) => {
		state.my_profile = profile
	}
}

export default{
	state, getters, actions, mutations
}